import styled from "@emotion/styled";
import { Table, TableHead } from "@mui/material";

export const StyledTable = styled(Table)`
  border-radius: 0.5rem 0.5rem 0 0;
  overflow: hidden;

  td {
    border: 1px solid #E5E5E5;
  }
`;

export const StyledTableHead = styled(TableHead)`
  background-color: #0A0A0A;

  .MuiTableCell-head {
    color: #FFFFFF;
    padding: 0.5rem 1rem;
  }
`;
export const AttrLinkSpan = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;

export const AttrLink = ({ children, onClick }) => {
  return <AttrLinkSpan onClick={onClick}>{children}</AttrLinkSpan>;
};
